<template>
  <div>
    <div class="ibox animated fadeInRightBig">
      <div class="ibox-title">
        <h3>
          Áreas X Turnos
          <i
            class="fa fa-clock-o"
            style="float: right; font-size: 21px; margin-top: -5px"
          ></i>
        </h3>
      </div>
      <form id="form">
        <div class="ibox-content">
          <br /><br />
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive-sm">
                <table class="table table-hover table-striped">
                  <thead>
                    <tr class="centered blue">
                      <td></td>
                      <td v-for="shift in shifts" :key="shift.id">
                        {{ shift.name }}
                      </td>
                      <td>Total de Colaboradores</td>
                      <!-- <td>Ação</td> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(team, index) in teams" :key="team.id">
                      <td class="blue">{{ team.name }}</td>
                      <td v-for="shift in team.shifts" :key="shift.id">
                        <input
                          type="number"
                          v-model="shift.pivot.people"
                          @change="teamChanged(index)"
                          disabled
                        />
                      </td>
                      <td>{{ team.totalPeople }}</td>
                      <!-- <td><button type='button' @click="saveTeam(index, team)" class='btn btn-primary' :disabled="team.disabledSave">Salvar</button></td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="ibox-footer">
                <div class="pull-right">
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
            </div> -->
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      teams: [],
      shifts: [],
      errors: undefined,
    };
  },
  computed: {
    dds_date: function () {
      return this.formattedDate(this.event.dds_date);
    },
  },
  methods: {
    teamChanged: function (index) {
      let teamRef = this.teams[index];
      teamRef.totalPeople = 0;
      teamRef.disabledSave = false;
      for (let i = 0; i < teamRef.shifts.length; i++) {
        teamRef.totalPeople += teamRef.shifts[i].pivot.people * 1;
      }
    },
    getTeams: function () {
      let self = this;
      let api = self.$store.state.api + "teams?with[]=shifts&paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          let res = response.data.data;
          for (let i = 0; i < res.length; i++) {
            res[i].disabledSave = true;
            res[i].totalPeople = 0;
            for (let j = 0; j < res[i].shifts.length; j++) {
              res[i].totalPeople += res[i].shifts[j].pivot.people;
            }
          }
          self.teams = res;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    getShifts: function () {
      let self = this;
      let api =
        self.$store.state.api + "shifts" + "?orderByAsc=id&paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.shifts = response.data.data;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    saveTeam: function (index, team) {
      this.teams[index].disabledSave = true;
      const self = this;
      const api = self.$store.state.api + "updateTeamsShifts";

      self.$http
        .post(api, team)
        .then((response) => {
          console.log(response);

          self.$message("Sucesso", `Salvo com sucesso`, "success");
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {
    this.getShifts();
    this.getTeams();
  },
};
</script>
<style scoped>
.centered {
  text-align: center;
}
.blue {
  background-color: rgb(84, 140, 220);
  color: white;
  border-right: 1px white solid !important;
}
td input {
  text-align: center !important;
  height: 35px;
}
thead td {
  border-right: 1px solid white;
}
</style>




// WEBPACK FOOTER //
// src/components/AreasTurnos/Matriz.vue